module.exports = __webpack_public_path__ + "static/img/hsyy.7d8e2f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hsyy.png
// module id = exb/
// module chunks = 0